import Plotly from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
const Plot = createPlotlyComponent(Plotly);

const WeatherChart = (props: { activeTabKey: any; date: any; data: { chartData: { [x: string]: any; date: any }[] }; onClickHandler: (arg0: Plotly.Datum) => void }) => {
  const map1x: any[] = [];
  const map1y: any[] = [];
  const map2y: any[] = [];
  props.data.chartData.forEach((item: { [x: string]: any; date: any }) => {
    map1x.push(item.date);
    map1y.push(item["Maximum Temperature"]);
    map2y.push(item["Minimum Temperature"]);
  });
  return (
    <Plot
      key={props.activeTabKey}
      data={[
        {
          type: "scatter",
          mode: "lines+markers",
          marker: {
            color: `#0072E3`,
          },
          name: "Minimum Temperature",
          x: map1x,
          y: map2y,
          line: {
            color: "#a2cefa",
            width: 0,
          },
        },
        {
          type: "scatter",
          mode: "lines+markers",
          marker: {
            color: `#0072E3`,
          },
          name: "Maximum Temperature",
          fill: "tonexty",
          x: map1x,
          y: map1y,
          line: {
            color: "#a2cefa",
            width: 0,
          },
        },
      ]}
      style={{ width: "100%" }}
      useResizeHandler={true}
      layout={{
        title: {},
        dragmode: false,
        xaxis: {
          showgrid: false,
          zeroline: true,
          showline: true,
          linecolor: "#DFE1E6",
          tickfont: {
            size: 12,
            color: "#0072E3",
            family: "Fira Sans",
          },
        },
        yaxis: {
          showgrid: false,
          showticklabels: false,
        },
        showlegend: false,
        margin: { l: 15, r: 10, t: 0, b: 25 },
        height: 200,
        // width: 450,
      }}
      onClick={(e) => {
        for (let i = 0; i < e.points.length; i++) {
          console.log(e.points[i].x, props.date);
          props.onClickHandler(e.points[i].x);
        }
      }}
      onHover={() => {
        let dragLayer: any = document.getElementsByClassName("nsewdrag")[0];
        dragLayer.style.cursor = "pointer";
      }}
      onUnhover={() => {
        let dragLayer: any = document.getElementsByClassName("nsewdrag")[0];
        dragLayer.style.cursor = "";
      }}
      onUpdate={() => {
        const _date = props?.date?.substr(props.date.length - 3);
        document.querySelector(`text[data-unformatted*="${_date}"]`)?.classList.add("xAxisLabelChangeColor");
      }}
      onAfterPlot={() => {
        const divs = document.querySelectorAll("text");
        divs.forEach((el) =>
          el.addEventListener("click", (event: any) => {
            console.log(event?.target?.textContent, props.date);
            props.onClickHandler(event?.target?.textContent);
          })
        );
      }}
    />
  );
};

export default WeatherChart;
